var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dusk Part 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 54,
    height: 46,
    rx: 2,
    ry: 2,
    style: {
      fill: "#cda1a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,50H55a4,4,0,0,1,4,4v0a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1v0a4,4,0,0,1,4-4Z",
    style: {
      fill: "#c4939c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,8H7a3,3,0,0,0-3,3V53a3,3,0,0,0,3,3H57a3,3,0,0,0,3-3V11A3,3,0,0,0,57,8Zm1,45a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H57a1,1,0,0,1,1,1Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,20,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,15,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,10,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,35,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,40,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,45,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,50,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,55,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,25,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,48a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V49A1,1,0,0,0,30,48Z",
    style: {
      fill: "#8d6c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,24h4a1,1,0,0,0,0-2H25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,22H33a1,1,0,0,0,0,2H51a1,1,0,0,0,0-2Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,30H25a1,1,0,0,0,0,2H51a1,1,0,0,0,0-2Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,38H43a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,40H39a1,1,0,0,0,0-2H25a1,1,0,0,0,0,2Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29,25.71a1,1,0,0,0,1.41,0l4-4a1,1,0,0,0-1.41-1.41L15,23.59l-1.29-1.29a1,1,0,0,0-1.41,1.41Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29,33.71a1,1,0,0,0,1.41,0l4-4a1,1,0,0,0-1.41-1.41L15,31.59l-1.29-1.29a1,1,0,0,0-1.41,1.41Z",
    style: {
      fill: "#faefde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,42a1,1,0,0,0,.71-.29l4-4a1,1,0,0,0-1.41-1.41L15,39.59l-1.29-1.29a1,1,0,0,0-1.41,1.41l2,2A1,1,0,0,0,15,42Z",
    style: {
      fill: "#faefde"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.a4677eab3b280d48a3dfc239f603a97a.svg";
export { ForwardRef as ReactComponent };